import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isEmpty, isNotEmpty } from '../../lib/ep.js';

import ActionLink from '../builder/ActionLink';
import SearchField from '../builder/SearchField';
import Select from '../builder/Select.js';
import Tooltip from '../builder/Tooltip.js';
import { useFilterData,operators } from '../FilterContent.js';

import StageMosaicItem from './StageMosaicItem';
import { localizeFields } from '../builder/DynamicFields.js';
import ToggleButton from '../builder/ToggleButton.js';

const SectionImage = ({ section, ...props }) => {
	const image_urls = [];
	const image_widths = [];

	if(isNotEmpty(section, 'image')) {
		if(isNotEmpty(section, 'mobile_image')) {
			image_urls.push(section.full_mobile_image);
			image_widths.push(400);
		}

		image_urls.push(section.full_image);
		image_widths.push(500);
	}

	const src_set = [];
	image_urls.map((image) => {
		src_set.push(`${image}`);
	});

	const image_sizes = [];
	image_widths.map((width, w) => {
		if(w < image_widths.length - 1) {
			image_sizes.push(`orientation:portrait`);
		} else {
			image_sizes.push(`orientation:landscape`);
		}
	});

	if(image_urls.length == 0) return null;

	return (
		<div class="sect_img">
			<picture>
				{image_urls.map((image, i) => {
					return (
						<source
							key={`bg_source_${i}`}
							media={`(${image_sizes[i]})`}
							srcSet={image}
						/>
					)
				})}

				<img src={src_set[src_set.length - 1]} alt="" />
			</picture>
		</div>
	)
};

export const StageSection = ({ section, state, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const [ is_section_folded, setIsSectionFolded ] = useState(false);

	const hide_empty_sections = props?.promo?.sections_hide_empty ?? false;
	const search_value = props?.search_value ?? '';

	const section_color = section?.color ?? false;
	const is_builder = props?.is_builder ?? false;
	const sections_enabled = props?.sections_enabled ?? false;
	const loaded_img = props?.loaded_img ?? false;

	const stages_to_display = props?.stages_to_display ?? [];

	const timezone = props.promo.timezone;
	let filtered_stages = stages_to_display.filter((s) => { 
		/*const open = (EPDateBefore(s.Stage.start_date) && EPDateAfter(s.Stage.end_date)) ? true : false;
		const closed = (EPDateBefore(s.Stage.end_date)) ? true : false;
		const pending = (!open && !closed) ? true : false;*/
		const open = (moment.tz(s.Stage.start_date, timezone).isBefore() && moment.tz(s.Stage.end_date, timezone).isAfter()) ? true : false;
		const closed = (moment.tz(s.Stage.end_date, timezone).isBefore()) ? true : false;
		const pending = (!open && !closed) ? true : false;

		const hide_expired_stages = props.promo?.stages_mosaic_hide_expired_stages ?? false;
		const hide_future_stages = props.promo?.stages_mosaic_hide_future_stages ?? false;
		return closed && !hide_expired_stages || pending && !hide_future_stages || open;
	});
	
	const stages_in_section = props.getStagesInSection(filtered_stages, section, false, sections_enabled);
	const jury_stages = props.getStagesInSection(filtered_stages, section, true, sections_enabled);

	if(section?.status == 0) return null;

	if(stages_in_section.length == 0 && jury_stages.length == 0 && ((section?.is_empty  ?? false) || hide_empty_sections)) return null;
	const add_section_toggler = (stages_in_section.length >= 4) ? true : false;

	let stage_header_styles = null;
	const stage_header_classes = ['stage_section_header'];
	if(add_section_toggler) stage_header_classes.push('has_toggler');
	if(!section_color) {
		stage_header_classes.push('gui_main_text_color_on_bg');
		stage_header_styles = { color:section_color };
	}

	return (
		<div>
			{(sections_enabled && section.id != 'no_section') && (
				<div class={stage_header_classes.join(" ")} style={stage_header_styles}>
					<SectionImage
						section={section}
					/>

					<div class="c">
						<h4 class="sect_title gui_main_text_color_on_bg">{(section.title != undefined) ? section.title : i18n("Section title")}</h4>

						{(add_section_toggler && search_value == '') && (
							<ToggleButton
								active={is_section_folded}
								color={false}
								icon='knk-arrow-b-big'
								icon_off='knk-arrow-t-big'
								onClick={() => setIsSectionFolded(!is_section_folded)}
								squared={true}
							/>
						)}
					</div>

					{(isNotEmpty(section, 'description')) && (
						<p class="sect_description gui_main_text_color_on_bg">{section.description}</p>
					)}
				</div>
			)}

			{(sections_enabled && section.id == 'no_section' && section.is_empty) && (
				<div class="stage_section_header gui_main_text_color_on_bg is_empty" />
			)}

			{(stages_in_section.length > 0) && (
				<div class={props.container_class.join(" ")} style={(!loaded_img || (is_section_folded && search_value == '')) ? { position:'fixed', left:'-110vw' } : null}>
					{stages_in_section.map((stage) => {
						return (
							<StageMosaicItem
								key={stage.Stage.id}
								click_action={() => props.goToStage(stage.Stage.promotion_id, stage.Stage.id)}
								brackets_list={props.brackets_list}
								is_builder={is_builder}
								participations={props.participations}
								promo={props.promo}
								stage={stage.Stage}
							/>
						)}
					)}
				</div>
			)}

			{(jury_stages.length > 0) && (
				<div class="jury_stages">
					{jury_stages.map((_stage) => {
						if(!_stage)return;
						const stage = _stage.Stage;

						const stage_description = (stage.display_description != undefined && stage.display_description != "") ? stage.display_description : false;

						return (
							<ActionLink
								key={stage.id}
								onClick={() => props.goToStage(stage.promotion_id, stage.id)}
								tooltip={<Tooltip position="top" autotranslate={false}>{stage_description}</Tooltip>}
								autotranslate={false}
							>{stage.display_title}</ActionLink>
						)}
					)}
				</div>
			)}

			{(stages_in_section.length > 0 && jury_stages.length > 0) && (
				<div class="empty_mosaic gui_main_text_color_on_bg">
					<p>{i18n("There is no participation stage/round open")}.</p>
				</div>
			)}
		</div>
	)
}

const StageMosaic = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ loaded_img, setLoadedImg ] = useState(false);
	const [ min_item_width, setMinItemWidth ] = useState(0);
	const [ brackets_list, setBracketsList ] = useState({});

	const is_builder = props?.is_builder ?? false;
	const stages = props.stages;
	const image_proportion = props.promo?.stages_mosaic_image_proportion ?? 'landscape';
	const site_layout = props.promo?.stages_mosaic_layout ?? 'mosaic';	// "mosaic" / "list"
	const min_stages_to_show_filter = 10;

	let stages_in_mosaic = stages.filter((obj) => { 
		if(props.promo?.stages_mosaic_hide_voting_galleries && obj.Stage.promotion_type_id == 37) return false;
		return (obj.Stage.hide_stage == undefined || !obj.Stage.hide_stage) ? true : false; 
	});
	switch(props.zone) {
		case 'success':
			if(props.promo.stages_in_success != 'all') {
				const timezone = props.promo.timezone;
				stages_in_mosaic = stages_in_mosaic.filter((st) => {
					const closed = (moment.tz(st.Stage.end_date, timezone).isBefore()) ? true : false;
					if (closed) return false;
					const participations = (props.participations[st.Stage.id] == undefined) ? {[st.Stage.id]:props.participations} : props.participations;
					if(props.promo.stages_in_success == 'only_open') {
						if(participations[st.Stage.id].next_participation == false) return false;
					}
					return true;
				});
			}
			break;

		case 'landing':
		case 'mosaic':
			if(!is_builder) {
				if(props.promo.stages_in_landing_bis != undefined && props.promo.stages_in_landing_bis != 'all') {
					stages_in_mosaic = stages_in_mosaic.filter((st) => {
						const participations = (props.participations[st.Stage.id] == undefined) ? {[st.Stage.id]:props.participations} : props.participations;
						if(props.promo.stages_in_landing_bis == 'only_open') {
							if(participations[st.Stage.id].next_participation == false) return false;
						}
						return true;
					});
				}
			}
			break;
	}

	let min_stage_width;
	let max_stages_per_row;

	if(image_proportion == 'landscape') {
		min_stage_width = (!is_builder) ? 250 : 190;
		max_stages_per_row = 3;
	} else {
		min_stage_width = (!is_builder) ? 160 : 120;
		max_stages_per_row = 4;
	}

	const num_stages_per_row = (stages_in_mosaic.length <= max_stages_per_row) ? stages_in_mosaic.length : max_stages_per_row;

	useEffect(() => {
		const item_selector = $('.gui_multiparticipation_landing > *:first-child');
		const paddings = parseFloat(item_selector.css('padding-left')) + parseFloat(item_selector.css('padding-right'));
		const margins = parseFloat(item_selector.css('margin-left')) + parseFloat(item_selector.css('margin-right'));
		const borders = 2 * parseFloat(item_selector.css('border-width'));
		const min_width = Math.ceil(min_stage_width + paddings + margins + borders);

		setMinItemWidth(min_width);

		if(window.device == 'desktop') window.addEventListener('resize', adaptToAvailableWidth, true);

		return () => {
			if(window.device == 'desktop') window.removeEventListener('resize', adaptToAvailableWidth);
		}
	}, [ stages_in_mosaic ]);

	useEffect(() => {
		setLoadedImg(true);
		adaptToAvailableWidth();
	}, [ min_item_width ]);

	useEffect(() => {
		if(props.brackets != undefined) {
			let _brs = (props.brackets.brackets != undefined) ? props.brackets.brackets : props.brackets;
			if (!_brs)return;
			let _brackets_list = {};

			_brs.map((bracket, b) => {
				_brackets_list[bracket.Bracket.id] = bracket.Bracket.title;
			});

			setBracketsList(_brackets_list);
		}
	}, []);

	useEffect(() => {
		if(state == undefined) return;
		dispatch({ type:'SETDATA', data:{ data:stages_in_mosaic } });
	}, [ props.stages ]);

	const shittySafariInAppHack = () => {
		var img_h = parseInt($('.stage_img img').height());
		if(img_h < 10 || true) {
			var img_w = parseFloat($('.stage_img img').width());
			var img_prop = 0.525;
			if($('.gui_multiparticipation_landing').hasClass('images_squared')) {
				img_prop = 1;
			} else if($('.gui_multiparticipation_landing').hasClass('images_portrait')) {
				img_prop = 1.5;
			} else if($('.gui_multiparticipation_landing').hasClass('images_landscape')) {
				img_prop = 0.525;
			} else {
				img_prop = 0.525;
			}

			$('.stage_img img').height(img_w * img_prop);
		}
	};

	const adaptToAvailableWidth = (event) => {
		let num_cols_class = Math.max(2, Math.min(num_stages_per_row, Math.floor($('.col_2').width() / min_item_width)));
		//if(isNaN(num_cols_class)) num_cols_class = 2;

		$('.gui_multiparticipation_landing').removeClass((index, css) => {
			return (css.match(/(^|\s)num_col_\S+/g) || []).join(' ');
		}).addClass('num_col_' + num_cols_class);

		setTimeout(() => {
			shittySafariInAppHack();
		}, 1000);
	};

	let animation_type = false;

	const container_class = ['gui_multiparticipation_landing', `images_${image_proportion}`, `is_${site_layout}`];
	if(stages_in_mosaic.length > 0) {
		if(stages.length == 2 || stages.length == 4) container_class.push('col_double');
		if((props.promo.stages_mosaic_hide_stage_border != undefined && props.promo.stages_mosaic_hide_stage_border) || site_layout == 'list') container_class.push('without_context');
		animation_type = (props.promo.stages_mosaic_open_animation != undefined && props.promo.stages_mosaic_open_animation != 'none') ? props.promo.stages_mosaic_open_animation : false;
		if(animation_type) {
			container_class.push(`is_animated ${animation_type}_animated`);
			if(animation_type == 'window') {
				const animation_anchor_point = props.promo?.stages_mosaic_open_animation_anchor ?? 'left';
				container_class.push(`${animation_anchor_point}_anchor`);
			}
		}
	}

	const goToStage = (promo_id, stage_id) => {
		if(is_builder) return false;

		const delay = (animation_type) ? 1000 : 1;
		const target_url = `/promotions/participate/${promo_id}/${stage_id}`;
		setTimeout(() => {
			window.self.location.href = target_url;

			/*if(window.force_open_in_self == undefined || !window.force_open_in_self) {
				window.self.location.href = target_url;
			} else {
				window.top.location.href = target_url;
			}*/
		}, delay);
	};

	const [ state, dispatch ] = useFilterData(stages_in_mosaic);

	const filter = {
		key:'search',
		name:"Name",
		tier1:['Stage.display_title','Stage.display_description'],
		tier2:{...operators.textOperators},
		tier3:'input',
		defaultT2:'like',
	};

	const sectionFilter = {
		key:'section',
		name:"Name",
		tier1:'Stage.section_id',
		tier2:{...operators.textOperators},
		tier3:'input',
		defaultT2:'like',
		type:'string',
	}

	const findStage = (k, v) => {
		dispatch({
			type:'SETFILTER',
			filter:{
				key:'search',
				value:v,
				operator:'like_all',
				filter,
			},
			unique:true,
		});
	};

	const setSection = (k, v) => {
		dispatch({
			type:'SETFILTER',
			filter:{
				key:'section_id',
				value:v,
				operator:'like_all',
				filter:sectionFilter,
			},
			unique:true,
		});
	};

	const getStagesInSection = (all_stages, section, jury_list, sections_enabled) => {
		if(jury_list == undefined) jury_list = false;
		return all_stages.filter((obj) => {
			const is_jury = (obj.Stage.voting_jury_mode != undefined) ? obj.Stage.voting_jury_mode : false;
			if(is_jury && !jury_list) return false;
			if(!is_jury && jury_list) return false;

			
			if(section.id == 'no_section' && (!sections_enabled || obj.Stage.section_id == undefined)) return true;
			return (obj.Stage.section_id == section.id) ? true : false;
		});
	};

	const stages_to_display = (state.filters.length > 0) ? state.filtered : state.data;
	const search_value = (state.filters.length > 0) ? state.filters.find((f) => (f.key == 'search'))?.value : '';
	const filter_section = (state.filters.length > 0) ? state.filters.find((f) =>(f.key == 'section_id'))?.value : '';

	let show_search_bar = props.promo?.stages_mosaic_show_search_bar ?? false;
	if(state?.data.length < min_stages_to_show_filter) show_search_bar = false;
	
	let sections_enabled = props.promo?.sections_enabled ?? false;
	const has_no_section = (getStagesInSection(stages_to_display, { id:'no_section' }, false, sections_enabled).length > 0) ? true : false;

	if(props.promo.stage_sections != undefined) {
		props.promo.stage_sections=localizeFields(props.promo.stage_sections, props.locale);
	}

	const stage_sections = (sections_enabled && props.promo.stage_sections != undefined) ? ((has_no_section) ? [...props.promo.stage_sections, { id:'no_section', title:i18n("No section"), is_empty:true }] : props.promo.stage_sections) : [{ id:'no_section' }];
	if(sections_enabled && stage_sections.length == 1) sections_enabled = false;

	const select_stage_sections = (sections_enabled) ? [
		{ k:'', v:i18n("All sections") },
		...stage_sections.map((section) => (
			{ k:section.id, v:section.title }
		)).sort(
			(a, b) => ((a.v < b.v) ? -1 : 1)
		)
	] : [];

	return (
		<div>
			{(show_search_bar) && (
				<div class="stages_filter" style={(sections_enabled) ? { gridTemplateColumns:'repeat(auto-fit, minmax(150px, 1fr))' } : null}>
					<SearchField
						_class={{first:true}}
						name="search"
						value={search_value}
						placeholder="Search"
						change={findStage}
					/>

					{(sections_enabled) && (
						<Select
							_class={{first:true}}
							name="section_id"
							values={select_stage_sections}
							value={filter_section}
							placeholder="Search"
							change={setSection}
						/>
					)}
				</div>
			)}

			{(props.promo.public_entries == 1) && (
				<div class="gui_main_text_color_on_bg">
					<ul class="success_actions gui_main_text_color_on_bg">
						<li class="entries_btn">
							<ActionLink
								_href={(!is_builder) ? `/entries/${props.promo.id}` : null}
								icon='knk-entries'
								_target="_parent"
							>View ranking</ActionLink>
						</li>
					</ul>
				</div>
			)}

			{stage_sections.map((section, index) => {
				return (
					<StageSection
						key={`section_${index}`}
						section={section}
						state={state}
						promo={props.promo}
						search_value={search_value}
						is_builder={is_builder}
						container_class={container_class}
						sections_enabled={sections_enabled}
						stages_to_display={stages_to_display}
						loaded_img={loaded_img}
						participations={props.participations}
						brackets_list={brackets_list}
						goToStage={goToStage}
						getStagesInSection={getStagesInSection}
					/>
				)
			})}
		</div>
	);
}

export default injectIntl(StageMosaic);